// ProjectsDetailPage component - Project detail layout
import React from 'react';
import HeaderOne from '../components/HeaderOne';
import Footer from '../components/Footer';
import PageHeader from '../../components/PageHeader.jsx';
import ProjectDetail from '../../components/ProjectDetail.jsx';

const ProjectsDetailPage: React.FC = () => {
  React.useEffect(() => {
  }, []);

  return (
    <div>
      <HeaderOne />
      <PageHeader title="Projets" />
      <ProjectDetail />
      <Footer />
    </div>
  );
};

export default ProjectsDetailPage;
